import { useMemo } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import type { RoleAuthorizationContext } from './roleAuthorization'

/** The role facts a route's rule reads where the Permissions Service does not answer for the organisation. */
export const useRoleAuthorizationContext = (): RoleAuthorizationContext => {
  const { role, hasConfigPermissions, isViewOnly } = useAuthenticatedUser().user
  const { ENABLE_ASSIGNEE_PERMISSIONS, P2P_ADMIN_MODE } = useFeatureFlags()

  return useMemo(
    () => ({
      session: { role, hasConfigPermissions, isViewOnly },
      orgFlags: {
        assigneePermissionsEnabled: ENABLE_ASSIGNEE_PERMISSIONS === true,
        p2pAdminModeEnabled: P2P_ADMIN_MODE === true,
      },
    }),
    [role, hasConfigPermissions, isViewOnly, ENABLE_ASSIGNEE_PERMISSIONS, P2P_ADMIN_MODE]
  )
}
